// Public recipe data comes exclusively from Supabase via
// `src/lib/public.functions.ts`. This module only exposes the
// shared `Recipe` type, category labels, and small formatting helpers.

export type RecipeCategory = "grigliate" | "primi" | "secondi" | "festivita" | "salumi";

export const RECIPE_CATEGORY_LABELS: Record<RecipeCategory, string> = {
  grigliate: "Grigliate",
  primi: "Primi",
  secondi: "Secondi",
  festivita: "Festività",
  salumi: "Salumi & taglieri",
};

export interface Recipe {
  slug: string;
  title: string;
  excerpt: string;
  cover: string;
  date: string; // ISO
  readingTime: number; // minuti
  category: RecipeCategory;
  tags: string[];
  intro: string;
  ingredients: { qty: string; item: string }[];
  steps: string[];
  tips?: string;
  productSlugs: string[];
  featured?: boolean;
  difficolta?: "Facile" | "Media" | "Esperta";
  porzioni?: number;
  tempoMinutes?: number;
}

export function formatRecipeDate(iso: string) {
  try {
    return new Date(iso).toLocaleDateString("it-IT", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
